// src/data/quizData.js
export const quizData = [
  {
    id: 1,
    question: 'I am very interested in new developments and discoveries in science, technology, and spirituality . I continuously enrich my knowledge of these areas.',
  },
  {
    id: 2,
    question: 'Before making any decision, even small, trivial matters, I always ask for advice from my friends and family.',
  },
  {
    id: 3,
    question: 'I am a well-organized person who likes to list everything I need to do. However, I sometimes list so many things that I don\'t know how to proceed.',
  },
  {
    id: 4,
    question: 'I am fascinated with martial arts, weaponry, and violence. I enjoy movies and TV series full of fighting and violence.',
  },
  {
    id: 5,
    question: 'I have a great imagination. When someone else describes something, I can clearly visualize what they\'re talking about.',
  },
  {
    id: 6,
    question: 'When I have to make a decision, I always have to analyze the pros and cons of each option carefully. This can make me appear to be indecisive to others.',
  },
  {
    id: 7,
    question: 'I am confident about my abilities and talents. I have a clear idea of the work that I want to do and what is important to my life.',
  },
  {
    id: 8,
    question: 'I am often jealous of others\' luck or wealth. I feel uncomfortably inferior when I am around others who are doing better than I am.',
  },
  {
    id: 9,
    question: 'In social situations, I stay as reserved as possible to avoid acting or speaking inappropriately.',
  },
  {
    id: 10,
    question: 'I will only build a deeper relationship with another person after I am fairly certain the other person likes me.',
  },
  {
    id: 11,
    question: 'I feel confident in social situations. I can converse with other people in a natural way that makes them feel at ease.',
  },
  {
    id: 12,
    question: 'I enjoy performing activities like mountain climbing, shopping, or seeing movies on my own. I enjoy having a quiet, personal space.',
  },
  {
    id: 13,
    question: 'I sometimes make up stories or distort facts just to see how other people react. I just do this to joke around, without bad intentions.',
  },
  {
    id: 14,
    question: 'There aren\'t many things in life that really bring me enjoyment.',
  },
  {
    id: 15,
    question: 'I don\'t take all the rules seriously. I do intense and exciting things like speeding and driving after drinking, despite being fully aware of what I am doing.',
  },
  {
    id: 16,
    question: 'I am frugal and plan my finances carefully. I might be considered stingy, but I think it\'s always worth saving for a rainy day.',
  },
  {
    id: 17,
    question: 'People around me say that I am too pessimistic, that I always see the bad side of things.',
  },
  {
    id: 18,
    question: 'When I am in a bad mood, I will express myself in dramatic ways, such as crying, breaking things, or harming myself.',
  },
  {
    id: 19,
    question: 'Friends and family will say that I was a troublemaker as a child. I caused others to worry by doing things like skip classes, fight, and tell lies.',
  },
  {
    id: 20,
    question: 'Ever since I was a child, I\'ve been seen as a \'good kid\'. I have never broken any rules or guidelines set by my parents and teachers.',
  },
  {
    id: 21,
    question: 'I am interested in the supernatural and I have a strong sixth sense. I can often sense something will happen before it occurs.',
  },
  {
    id: 22,
    question: 'In social situations, I like to be the center of attention.',
  },
  {
    id: 23,
    question: 'I am in love with being in love, and will often rush into being in a relationship. However, I sometimes find myself angry or disgusted by even my partner\'s minor shortcomings.',
  },
  {
    id: 24,
    question: 'I have been described as emotionally inexpressive, to the point of appearing indifferent or having a constant poker face.',
  },
  {
    id: 25,
    question: 'I don\'t like to be restricted in anything I do. I don\'t make detailed plans and find it difficult to pay attention to rules and procedures.',
  },
  {
    id: 26,
    question: 'I am good at interacting with others. In a group, I am always the focus of attention.',
  },
  {
    id: 27,
    question: 'Although people say that inner beauty is more important than outer beauty, I still feel that one\'s appearance cannot be ignored. So, I make sure to spend some time each day to make sure I look good .',
  },
  {
    id: 28,
    question: 'When I spend time with other people, I have some difficulty just relaxing and enjoying their company. I can only feel at ease if I know that everyone else\'s needs have been met first.',
  },
  {
    id: 29,
    question: 'I usually rely on my family or significant other  to help me make important decisions.',
  },
  {
    id: 30,
    question: 'I feel uncomfortable when receiving honest and sincere care from other people. On the other hand, I enjoy helping others solve their problems.',
  },
  {
    id: 31,
    question: 'I am a perfectionist and make strict demands of myself. As a result, I tend to spend more time at work than other people.',
  },
  {
    id: 32,
    question: 'While it might be bragging, I consider myself as a particularly special individual.',
  },
  {
    id: 33,
    question: 'I have a unique sense of fashion and lifestyle. This sets me apart from other people , which might cause them to think of me as strange or weird.',
  },
  {
    id: 34,
    question: 'When things don\'t go according to my wishes, I can\'t help but lose my temper regardless of circumstances or consequences.',
  },
  {
    id: 35,
    question: 'I dislike being in places with crowds, like festivals, parties, and large social events. If I need to be around and interact with lots of people, I become physically and mentally exhausted.',
  },
  {
    id: 36,
    question: 'My colleagues and supervisors don\'t understand or utilize my talents.',
  },
  {
    id: 37,
    question: 'I have very few close friends outside of my family.',
  },
  {
    id: 38,
    question: 'When I am around people I don\'t know, I am often overwhelmed  by shyness or anxiety.',
  },
  {
    id: 39,
    question: 'I lack persistence. I give up on tasks halfway, procrastinate, or fail to put in due diligence.',
  },
  {
    id: 40,
    question: 'I am so conscious of privacy concerns that I avoid sharing personal information with others as much as possible. You never know how others might use your information for their own profit.',
  },
  {
    id: 41,
    question: 'I have to flaunt my charisma in a crowd, hoping that others find me attractive or sexy.',
  },
  {
    id: 42,
    question: 'When a romantic relationship with me is ended, I feel lonely and helpless, leading me to desperately seek a new relationship.',
  },
  {
    id: 43,
    question: 'I believe a strictly managed workplace to be very important. Employees must be rigorously trained for their roles and to follow company policies.',
  },
  {
    id: 44,
    question: 'Whether I\'m being criticized or praised, I usually don\'t show an obvious or strong emotional reaction.',
  },
  {
    id: 45,
    question: 'My emotions can swing greatly due to external factors and my environment, outside of my control.',
  },
  {
    id: 46,
    question: 'I love to be in the company of friends and enjoy going out with others. I just can\'t stand being alone.',
  },
  {
    id: 47,
    question: 'I prefer doing things on my own whenever it is possible.',
  },
  {
    id: 48,
    question: 'When I describe events or express my feelings, I do so in a lively and dramatic fashion.',
  },
  {
    id: 49,
    question: 'I have been told that I express a strong individuality. When someone provokes me, I always need to fight back wholeheartedly.',
  },
  {
    id: 50,
    question: 'I have an exceptional ability to sense other peoples\' intentions . I get this sense even if the other person is only in the early stages of their planning.',
  },
  {
    id: 51,
    question: 'When I am under pressure, I can become a bit erratic. In these situations, I can end up having wild thoughts, suspect others, or act evasive.',
  },
  {
    id: 52,
    question: 'I enjoy exploiting loopholes in laws and rules as far as I can\'t be punished.',
  },
  {
    id: 53,
    question: 'I have mild-tempered disposition. It is rare for me to lose control and yell.',
  },
  {
    id: 54,
    question: 'I am highly dependent on my romantic partner. I often worry that if I lose them, I won\'t be able to take care of myself.',
  },
  {
    id: 55,
    question: 'I like to help others complete their tasks, to the point where I sometimes feel like I\'ve taken on too much of their responsibilities.',
  },
  {
    id: 56,
    question: 'I am a talented and successful person. Therefore, I deserve special treatment in certain circumstances.',
  },
  {
    id: 57,
    question: 'I could be considered a pack rat. I have trouble throwing things out even if they are old, have no use, or have no sentimental value.',
  },
  {
    id: 58,
    question: 'I dislike repetitive tasks. I will sometimes procrastinate on things I need to do in order to work on things that I want to do.',
  },
  {
    id: 59,
    question: 'I have been characterized as like a chivalrous knight or superhero, who tries to rescue others in trouble and speak out against injustices. ',
  },
  {
    id: 60,
    question: 'Some might call me arrogant, but I don\'t care about their opinions.',
  },
  {
    id: 61,
    question: 'I often feel anxiety when I am at big social gatherings. Even if I am with people I know, I still feel like other people are judging me.',
  },
  {
    id: 62,
    question: 'I have a cowardly disposition. I have a hard time trying out new things, and prefer staying in my comfort zone.',
  },
  {
    id: 63,
    question: 'I am well-known to be rational-minded. I always have to analyze things before acting, to the point where I sometimes get overly worried about my decision.',
  },
  {
    id: 64,
    question: 'I don\'t care what others think or say about me. I act honestly in line with my feelings and mood, even if it may not be socially appropriate.',
  },
  {
    id: 65,
    question: 'I have no patience for performing repetitive tasks; I don\'t like to perform chores. Because of this, some people might consider me to be irresponsible.',
  },
  {
    id: 66,
    question: 'I\'ve been told that I express my feelings in such an exaggerated way that they don\'t know how sincere I am.',
  },
  {
    id: 67,
    question: 'Family members and subordinates have complained that I lay down so many rules and with such strictness that they don\'t have enough independence.',
  },
  {
    id: 68,
    question: 'I will hold grudges against those who are disloyal or disrespectful to me.',
  },
  {
    id: 69,
    question: 'I am at my happiest and my life feels most meaningful when I am helping others.',
  },
  {
    id: 70,
    question: 'I have a lot of trouble making decisions when there\'s a gap between what I should do and what I want to do. Usually, I will go with what I want to do, even though it makes me feel guilty.',
  },
  {
    id: 71,
    question: 'I am an imposing person. People have told me that they\'ve followed my direction because they were afraid of me.',
  },
  {
    id: 72,
    question: 'I am very emotional, with even trivial matters causing me to anger. I can switch between being happy, sad, anxious, and angry within a few hours\' time span. However, I tend to not be in a negative state for very long.',
  },
  {
    id: 73,
    question: 'I don\'t like to try novel or adventurous things. This is because I am afraid of facing the unknown or making a mistake and embarrassing myself.',
  },
  {
    id: 74,
    question: 'I am more than willing to indulge myself if the mood strikes me. This might result in me going to big parties, going for a drive, or going on a shopping spree.',
  },
  {
    id: 75,
    question: 'I hate having to navigate complicated interpersonal relationships and social intrigue. If I could become a hermit and seclude myself from the rest of the world, I would.',
  },
  {
    id: 76,
    question: 'I\'ve been called a workaholic. Even if I was so wealthy that I didn\'t need to work, I would still be working hard.',
  },
  {
    id: 77,
    question: 'I like imagining that I have fame and admiration, through having great wealth, ability, or appearance.',
  },
  {
    id: 78,
    question: 'Even if it might require me to go out of my way, I do my best to help other people out so that they will like me.',
  },
  {
    id: 79,
    question: 'I often misunderstand other people as having a crush on or being attracted to me. This false assumption has caused me trouble and embarrassment.',
  },
  {
    id: 80,
    question: 'I don\'t have a strong yearning or desire when it comes to pursuing love.',
  },
  {
    id: 81,
    question: 'I am rarely satisfied by my successes. There will always be other challenges to overcome.',
  },
  {
    id: 82,
    question: 'I will always try to present an agreeable façade towards others\' opinions. If I disagree with someone\'s stance, I will hide my discontent.',
  },
  {
    id: 83,
    question: 'Throughout my life, teachers and other authority figures have often told me that I could achieve much more if only I would put more effort into my work.',
  },
  {
    id: 84,
    question: 'I sometimes feel that the people around me, including family, friends, and colleagues, are not as loyal to me as I expect them to be.',
  },
  {
    id: 85,
    question: 'I believe there may be times where we have to sacrifice other peoples\' desires in order to achieve our own goals.',
  },
  {
    id: 86,
    question: 'I am often critical of my superiors at work. I feel like I could do things better than they can.',
  },
  {
    id: 87,
    question: 'Others find me to be very humorous. Even boring, ordinary things can become interesting if I\'m describing them.',
  },
  {
    id: 88,
    question: 'I sometimes find myself mocking others for their misfortunes. I\'m not particularly proud of this behavior; it simply reflects my belief in the survival of the fittest.',
  },
  {
    id: 89,
    question: 'I lack self-confidence and often doubt my own abilities. I sometimes consider myself to be useless.',
  },
  {
    id: 90,
    question: 'My mind often races with disordered thoughts. I can often take a lot of time and energy to capture and organize these thoughts to find solutions; this can cause me to neglect my daily needs.',
  },
  {
    id: 91,
    question: 'I am not a proactive person. When I\'m in a group, I prefer to be a loyal follower than a leader.',
  },
  {
    id: 92,
    question: 'I have no hesitation to talk to other people about my problems. However, I often have trouble accepting their aid and financial support.',
  },
  {
    id: 93,
    question: 'I\'ve been told that I speak in a blunt and unrelenting way. If other people think that I\'m being unreasonable, they should be confident enough to defend themselves.',
  },
  {
    id: 94,
    question: 'I have perceptive senses that most other people lack. Sometimes, I have a sixth sense for unknown phenomena, like seeing the spirits of dead relatives or picking up special energies.',
  },
  {
    id: 95,
    question: 'When I am in social situations, I wish that I didn\'t worry so much about how other people perceive me.',
  },
  {
    id: 96,
    question: 'When I am asked by someone to do something I don\'t want to do, I will make things difficult for them by intentionally being argumentative.',
  },
  {
    id: 97,
    question: 'I have a free spirit that won\'t accept traditional thinking and doesn\'t care what others think about me. ',
  },
  {
    id: 98,
    question: 'I have been told by others that I am too stubborn. I insist on things being done using methods that I set and personally supervise processes as much as possible. I don\'t mind being called stubborn as long as things aren\'t left unfinished or done improperly. ',
  },
  {
    id: 99,
    question: 'I sometimes keep the truth to myself in order to play tricks, dodge responsibilities, or otherwise benefit myself.',
  },
  {
    id: 100,
    question: 'I often have insecurities about romantic relationships and worry about whether or not my partner is being loyal to me.',
  },
  {
    id: 101,
    question: 'I put high value on my privacy and tend to keep my emotions and interests to myself. This can cause others to think of me as evasive or make them feel they can\'t understand me.',
  },
  {
    id: 102,
    question: 'I have a guarded personality and find it hard to trust others. Even when I try to believe in other people, I can\'t help but worry that they might end up taking advantage of me.',
  },
  {
    id: 103,
    question: 'Some say that I overreact to imagined matters like a hypochondriac. They don\'t understand that these unfortunate matters have actually happened to me.',
  },
  {
    id: 104,
    question: 'Some people have said that I have a bad sense for romantic relationships. Romantic relationships tend to just end in disappointment and sadness. I can\'t understand my lack of good judgment.',
  },
  {
    id: 105,
    question: 'I consider myself as upper class. The people and organizations I associate with carry significant influence and importance in society.',
  },
  {
    id: 106,
    question: 'I often feel empty inside, like I don\'t know about my place in the world. I don\'t have a clear goal or purpose for where I want to take my life.',
  },
  {
    id: 107,
    question: 'I prefer my own way of going about things. If someone tries to change my ways, I will stubbornly ignore their opinions.',
  },
  {
    id: 108,
    question: 'While I might be called lazy or a procrastinator, I believe that life is short and that you need to enjoy it. You don\'t need to spend so much time on things that they\'re perfect, only that they\'re done well enough.',
  },
  {
    id: 109,
    question: 'I have been told that I express myself in a unique way. Sometimes other people say they find it difficult to understand what I\'m trying to communicate.',
  },
  {
    id: 110,
    question: 'I don\'t think I need to feel guilty about past misbehaviors.',
  },
  {
    id: 111,
    question: 'I have been told that I am too strict with myself and that I feel too much guilt or blame for even small mistakes.',
  },
  {
    id: 112,
    question: 'I have been told that I am self-centered. Even when I say that I understand another party\'s feelings, they respond by saying that I don\'t demonstrate that understanding.',
  },
  {
    id: 113,
    question: 'I feel that jealousy is just a part of life. It is natural for me to be jealous of what other people have, and they may at the same time covet things that are mine.',
  },
  {
    id: 114,
    question: 'I can\'t stand the stress and realities of social interactions. I prefer fantasizing through the ideals of celebrity news and variety shows.',
  },
  {
    id: 115,
    question: 'I tend not to carry very strong opinions. If I\'m not careful, I can easily be swayed by other people.',
  },
  {
    id: 116,
    question: 'I feel most secure when I am around other people. If I had to live on my own, I wouldn\'t know how to take care of myself.',
  },
  {
    id: 117,
    question: 'I have been called serious or tight-laced. However, I think there\'s no good reason to violate good moral conduct.',
  },
  {
    id: 118,
    question: 'I do not consider myself to be carefree. I carry a lot of worries that lead me to act cautiously and conservatively.',
  },
  {
    id: 119,
    question: 'I have a boundless imagination. I am known among friends as a fountain of ideas.',
  },
  {
    id: 120,
    question: 'I highly value being praised for my talents. If I feel that others are overlooking me, I will find ways to gain their appreciation.',
  },
  {
    id: 121,
    question: 'I sometimes worry that family and close friends don\'t reciprocate my affection for them. I often need to reach out to affirm that they still like me, despite the fact that I know this might annoy them.',
  },
  {
    id: 122,
    question: 'I feel better when working in a smaller team rather than a larger team because I don\'t want coworkers doubting or criticizing my competence.',
  },
  {
    id: 123,
    question: 'Friends have said that I am not always easy to get along with since I can be emotionally fickle and sensitive.',
  },
  {
    id: 124,
    question: 'I like to be the person in control when it comes to any relationship, personal or at work. This can sometimes make me come across as rude, harsh, or uncaring.',
  },
  {
    id: 125,
    question: 'I have been told that I have talents that could be of use to help other people. However, I can\'t say that I\'ve actually used my skills to benefit myself or my family.',
  },
  {
    id: 126,
    question: 'When faced with a challenge, I first evaluate the possible risks and chances of success. I will not proceed unless I am fairly confident of success.',
  },
  {
    id: 127,
    question: 'There are people out there who deliberately bother or insult me, just to provoke me.',
  },
  {
    id: 128,
    question: 'I have been called naïve or ignorant, and perhaps too tolerant of others. I am at risk of being taken advantage of without realizing it.',
  },
  {
    id: 129,
    question: 'I don\'t feel the need to build close relationships with lots of other people. I prefer to focus my energies internally on philosophy, abstract concepts, and the supernatural.',
  },
  {
    id: 130,
    question: 'I prefer to handle challenges by myself. I feel uncomfortable when others offer to help and have a hard time accepting their aid.',
  },
  {
    id: 131,
    question: 'I usually go about my work by setting and carrying out short- and medium-term plans. Once plans have been set, I do my best to stick with them.',
  },
  {
    id: 132,
    question: 'When working on a project, I am able to establish an efficient plan of action. I usually have enough time to review and correct things, and often finish before the deadline.',
  },
  {
    id: 133,
    question: 'When taking on any project, I need to gather as much information as possible, checking any existing standards and procedures, just to make sure that the task is executed smoothly.',
  },
  {
    id: 134,
    question: 'I am always focused on my work, to the point where I sometimes forget to eat or lose sleep.',
  },
  {
    id: 135,
    question: 'I follow the saying that you should never put off until tomorrow what you can do today. My persistence in following this philosophy has sometimes caused trouble for family, friends, and coworkers.',
  },
  {
    id: 136,
    question: 'I am a well-organized person. Although it may make me appear strict, everything needs to be sorted and put into its proper place, whether at home or at work.',
  },
  {
    id: 137,
    question: 'I am serious about keeping promises. I will do my best to fulfill promises I have made, even it might cause me a great amount of trouble.',
  },
  {
    id: 138,
    question: 'I try to keep a low profile at work; I don\'t boast about my achievements.',
  },
  {
    id: 139,
    question: 'I believe it is possible to obtain wealth through ethical means. I will not harm others just to benefit myself.',
  },
  {
    id: 140,
    question: 'I would rather be taken advantage of than take advantage of others, even if this might cause me to suffer.',
  },
];